import { useMemo, useState, useEffect, Suspense, lazy, useCallback } from "react";
import { useFirestoreGeneralOrderBy } from "../../firebase/useFirestore";
import HomeMultipleBarChart from "../Visualisations/moment/HomeMultipleBarChart";
import ArrowLeftIcon from "../../images/icons/arrow-left-icon.png";
import ArrowRightIcon from "../../images/icons/arrow-right-icon.png";
import Location from "../../hooks/Location";
import isQuestionField from "../../helpers/questionnaire/isQuestionField";

const ResearchData = lazy(() => import("../Research/ResearchData"));

const LiveReportResearchData = ({ questionnaireId, researchId, startDate, endDate }) => {
  // State
  const [visible, setVisible] = useState(0);
  const [openPage, setOpenPage] = useState(false);

  // Hooks
  const page = Location()[2];

  // Firestore
  const questionnaireFields = useFirestoreGeneralOrderBy(
    "QuestionnaireFields",
    "QuestionnaireID",
    questionnaireId ? questionnaireId : "123",
    "Position",
    "asc"
  );

  const visibleFields = useMemo(() => {
    return Array.isArray(questionnaireFields)
      ? questionnaireFields.filter((item) => isQuestionField(item) && item.LiveReportHidden === false)
      : [];
  }, [questionnaireFields]);

  // Set page type
  useEffect(() => {
    setOpenPage(page === "livereportopen");
  }, [page]);

  // Which list are we paging through?
  const fieldsForPaging = useMemo(() => {
    // Open page: only show visible fields
    if (openPage) return visibleFields;

    // Default: allow browsing all fields
    return Array.isArray(questionnaireFields) ? questionnaireFields.filter(isQuestionField) : [];
  }, [openPage, visibleFields, questionnaireFields]);

  const total = fieldsForPaging.length;

  // Keep visible index valid when list changes (async load / toggles)
  useEffect(() => {
    if (!total) return;
    if (visible > total - 1) setVisible(0);
  }, [total, visible]);

  const nextIndicator = useCallback(() => {
    if (!total) return;
    setVisible((v) => (v < total - 1 ? v + 1 : 0));
  }, [total]);

  const previousIndicator = useCallback(() => {
    if (!total) return;
    setVisible((v) => (v > 0 ? v - 1 : total - 1));
  }, [total]);

  const currentField = total ? fieldsForPaging[visible] : null;

  return (
    <>
      {/* Navbar */}
      <div id="live-report-effect-indicator-navbar" style={{ display: "flex" }}>
        <div
          className="live-report-effect-indicator-navbar-button-container"
          onClick={previousIndicator}
        >
          <img src={ArrowLeftIcon} alt="Vorige" />
          <p className="live-report-effect-indicator-navbar-button">Vorige</p>
        </div>

        <div>
          <p>{total ? `${visible + 1} van de ${total}` : "0 van de 0"}</p>
        </div>

        <div
          className="live-report-effect-indicator-navbar-button-container"
          onClick={nextIndicator}
        >
          <p className="live-report-effect-indicator-navbar-button">Volgende</p>
          <img src={ArrowRightIcon} alt="Volgende" />
        </div>
      </div>

      {/* Only mount the currently visible field */}
      {currentField ? (
        <div key={currentField.ID} className="home-kpi-container">
          <Suspense fallback={null}>
            <ResearchData
              fieldType={currentField.Type}
              fieldId={currentField.ID}
              researchId={researchId}
              docid={currentField.docid}
              graphType={currentField.GraphType}
              liveReportHidden={currentField.LiveReportHidden}
              paragrapgMomentVisibilityStyle={currentField.ParagraphMomentVisibilityStyle}
              startDate={startDate}
              endDate={endDate}
            />
          </Suspense>
        </div>
      ) : (
        <HomeMultipleBarChart field={[{ ID: "123" }]} moment={"123"} />
      )}
    </>
  );
};

export default LiveReportResearchData;
